import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnAU: CultureInfo = {
  name: 'en-AU',
  displayName: 'English (Australia)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-AU',
  parent: CultureInfoEn
};
